const WechatGreenOutline = ({ height = 16, width = 16 }) => (
  <svg
    height={height}
    width={width}
    fill="none"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M235.3 17.101C339.7 20.601 447.6 106.601 429.6 219.001C429.1 222.401 431.2 223.401 433.2 224.701C454.6 239.101 471.8 257.401 483.1 280.701C507.1 330.201 498.4 386.601 460.3 426.601C454.2 433.001 451.1 438.701 452.7 447.801C455.2 463.001 456.2 478.201 457.5 493.601C445.9 489.501 407.6 462.701 400.3 466.901C317 499.101 211.7 463.501 182.8 374.701C182 372.201 181 370.801 178.3 370.201C166.6 367.201 155 363.801 143.4 360.801C141.4 360.301 138.7 360.401 136.9 361.401C117.6 371.401 99.0999 381.701 79.6999 391.701C81.6999 372.701 83.0999 355.001 85.4999 336.301C86.1999 331.401 84.6999 328.401 80.8999 325.301C-68.3001 198.101 61.7999 6.20097 235.3 17.101ZM404 208.301C414.6 94.301 283.8 24.701 183.5 47.901C48.5999 68.401 -12.9001 231.001 109 313.601C118.2 319.901 110.8 334.101 111.4 344.601C121 341.001 134.2 328.601 142.7 331.901C153.9 335.901 165.2 339.501 176.8 343.401C173.5 228.501 306.4 168.201 404 208.301ZM425.8 446.601C425.2 434.901 420.1 423.601 432.8 416.701C556.2 290.001 348.1 155.301 239.2 259.501C131.4 367.601 286.9 497.601 401.7 437.601C410.1 434.401 417.5 443.701 425.8 446.601Z"
      fill="#0E9F6E"
    />
    <path
      d="M157 176.698C142.3 176.798 130.2 164.898 130.2 150.198C130.2 135.398 142.1 123.498 156.9 123.598C171.5 123.598 183.3 135.298 183.5 149.898C183.6 164.398 171.6 176.598 157 176.698Z"
      fill="#0E9F6E"
    />
    <path
      d="M317.4 150.2C317.4 165 305.5 176.8 290.6 176.7C275.9 176.6 264.2 164.6 264.3 149.7C264.4 135.1 276.2 123.5 290.8 123.5C305.8 123.5 317.5 135.2 317.4 150.2Z"
      fill="#0E9F6E"
    />
    <path
      d="M306.9 308.902C306.8 320.702 297.3 330.102 285.5 330.002C273.7 329.902 264.4 320.402 264.5 308.502C264.6 296.802 274.3 287.202 285.9 287.302C297.6 287.502 307 297.102 306.9 308.902Z"
      fill="#0E9F6E"
    />
    <path
      d="M388.1 329.999C376.3 330.099 366.7 320.699 366.6 308.899C366.5 297.299 376.1 287.499 387.7 287.399C399.3 287.299 409 296.899 409.1 308.599C409.3 320.299 399.8 329.899 388.1 329.999Z"
      fill="#0E9F6E"
    />
  </svg>
);

export default WechatGreenOutline;
